let brief = {
    "Active": true,
    "Name": "JSON script",
    "Owner": null,
    "AiScriptGenerator": {
        "Oid": "70779e3a-7ef4-4725-a925-94a481049149"
    },
    "IsPublic": true,
    "LogoUrl": "https://adthosgenericfiles.blob.core.windows.net/default/d3f9e990-ca49-4a8d-b475-da01176c1485-unnamed.png",
    "AllowedVoices": 0,
    "DefaultLanguage": {
        "Name": "English - United States of America",
        "Code": "en-US",
        "VoiceTargetRating": 8,
        "MinCountVoices": 5
    },
    "OpenCreativeStudio": false,
    "AllowedLanguagesCodes": "nl-NL, en-US, en-GB",
    "ShowProducerRequest": true,
    "IsOverride": false,
    "Oid": "f2cb7267-4d0a-4dea-821a-8f4ef0b53500"
}

let steps = [
    {
        "Name": "Demo step",
        "Description": "Demo step description 1",
        "Hint": "Demo step hint",
        "Picture": null,
        "Order": 0,
        "BriefId": "f2cb7267-4d0a-4dea-821a-8f4ef0b53500",
        "Demos": [],
        "Oid": "5181aed6-9260-4164-b8df-c2718e897e56",
        "Questions": null,
        "Rows": null,
        "__visibleQuestions": null,
        "Step": null
    }
]

let stepsQuestions = [
    [
        {
            "Order": 1,
            "Question": "Promotion",
            "PromptValue": "Promotion",
            "Hint": null,
            "IsRequired": true,
            "AiPrompt": true,
            "BriefQuestionType": 2,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 1,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "a4cd231d-e675-4582-9594-633806cbf575"
        },
        {
            "Order": 1,
            "Question": "Advertiser",
            "PromptValue": "Advertiser",
            "Hint": null,
            "IsRequired": true,
            "AiPrompt": true,
            "BriefQuestionType": 2,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 1,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": "Demo placeholder",
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "d9249787-884a-4672-8666-37b3872fc50c"
        },
        {
            "Order": 3,
            "Question": "Topic",
            "PromptValue": "Topic",
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 2,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 1,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": {
                "Oid": "a4cd231d-e675-4582-9594-633806cbf575"
            },
            "ClientRequest": false,
            "Oid": "95a030bc-9a3d-450b-82bb-9eb591311626"
        },
        {
            "Order": 4,
            "Question": "Language",
            "PromptValue": "Language",
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 9,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "5db94894-809f-42af-a65c-f170d426e9c0"
        },
        {
            "Order": 5,
            "Question": "Music",
            "PromptValue": "Music",
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 0,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "6a83a803-8afd-43d5-9c76-4d7c69e2af01"
        },
        {
            "Order": 6,
            "Question": "Email creative",
            "PromptValue": null,
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 10,
            "Meaning": 0,
            "EmailAim": 1,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "e3f0a859-d8c9-458a-9571-7c14e81fff86"
        },
        {
            "Order": 8,
            "Question": "Other email question",
            "PromptValue": null,
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 10,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": {
                "Oid": "e3f0a859-d8c9-458a-9571-7c14e81fff86"
            },
            "ClientRequest": false,
            "Oid": "0ce40b9c-55fc-4b19-86c0-5e95c12279de"
        },
        {
            "Order": 9,
            "Question": "Date",
            "PromptValue": null,
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 3,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "5b82ca49-f86c-4bd5-9028-211d131393df"
        },
        {
            "Order": 9,
            "Question": "Time",
            "PromptValue": null,
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 4,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 1,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "2c609c1f-3c40-406b-8daf-5f52f7d3e07c"
        },
        {
            "Order": 11,
            "Question": "Some demo header",
            "PromptValue": null,
            "Hint": "Some demo header",
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 13,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": "18",
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "69d5752b-7d8f-4c5b-bbc5-6a52d67adb44"
        },
        {
            "Order": 12,
            "Question": "Some demo label (without specified font-size). Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?",
            "PromptValue": null,
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 13,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "9c983fff-c2af-4ecc-a3e5-56e78a7eaf7d"
        },
        {
            "Order": 13,
            "Question": "Enter website url",
            "PromptValue": null,
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 14,
            "Meaning": 0,
            "EmailAim": 0,
            "TextEditorType": 0,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": true,
            "Oid": "3e7bb17c-42eb-4d31-80e0-4b4c70ae8317"
        },
        {
            "Order": 14,
            "Question": "Creative name",
            "PromptValue": null,
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 2,
            "Meaning": 1,
            "EmailAim": 0,
            "TextEditorType": 1,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "6db1b766-0fbd-4dc1-ba0c-cd86d8825adb"
        },
        {
            "Order": 15,
            "Question": "ISCI",
            "PromptValue": null,
            "Hint": null,
            "IsRequired": false,
            "AiPrompt": true,
            "BriefQuestionType": 2,
            "Meaning": 2,
            "EmailAim": 0,
            "TextEditorType": 1,
            "FileEditorType": 0,
            "MinValue": 0,
            "MaxValue": 0,
            "Placeholder": null,
            "IndexInRow": 0,
            "Width": null,
            "BriefPickListId": null,
            "FontSize": null,
            "BriefStepId": "5181aed6-9260-4164-b8df-c2718e897e56",
            "DependsOnQuestion": null,
            "DependsOnItem": null,
            "SimilarQuestion": null,
            "ClientRequest": false,
            "Oid": "cede028b-b17e-4351-a39b-e99f8fa28e93"
        }
    ]
]

export default {
    brief,
    steps,
    stepsQuestions
};